
  const __registry__ = require('../../../../spiferack/client/index.js')
  var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = require('react');
var AuditLogContainer = require('./common/auditLogContainer');

var _require = require('./common/filterActions'),
    OrgFilterAction = _require.OrgFilterAction;

var SpaceGap = require('./common/spaceGap');

var OrgAddUser = function (_React$PureComponent) {
  _inherits(OrgAddUser, _React$PureComponent);

  function OrgAddUser() {
    _classCallCheck(this, OrgAddUser);

    return _possibleConstructorReturn(this, (OrgAddUser.__proto__ || Object.getPrototypeOf(OrgAddUser)).apply(this, arguments));
  }

  _createClass(OrgAddUser, [{
    key: 'render',
    value: function render() {
      var log = this.props.log;

      return React.createElement(
        AuditLogContainer,
        this.props,
        React.createElement(
          'b',
          null,
          log.actor_name
        ),
        React.createElement(SpaceGap, null),
        React.createElement(
          'span',
          null,
          'invited user ' + log.actee_name + ' to org'
        ),
        React.createElement(SpaceGap, null),
        React.createElement(OrgFilterAction, { text: log.org_name }),
        React.createElement(SpaceGap, null),
        React.createElement(
          'span',
          null,
          'as ' + log.event_metadata.role
        )
      );
    }
  }]);

  return OrgAddUser;
}(React.PureComponent);

module.exports = OrgAddUser;
  let __hot__
  
  __registry__.register('audit-logs/actions/orgAddUser', module.exports, __hot__)
  